import { render, staticRenderFns } from "./personSelectPc.vue?vue&type=template&id=6264aa19&"
import script from "./personSelectPc.vue?vue&type=script&lang=js&"
export * from "./personSelectPc.vue?vue&type=script&lang=js&"
import style0 from "./personSelectPc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports